export const typeOfComplaints = { types: "types", users: "users" };
